import { render } from "./HeroiconsSolidBookOpen.vue?vue&type=template&id=ec073da6"
const script = {}

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBookOpen.vue"]])

export default __exports__